import * as http from '../../request/http';
import { getBreakdownProperties, hydrateSchema, parseSchema } from './UnifiedEventsSchema';
import PortalIdParser from 'PortalIdParser';
const fetchSchema = (reportType, schemaVersion) => {
  return http.get(`events/internal/v0/reports/schemas/${reportType}/${schemaVersion || 'default'}`, {
    query: {
      includeImplicitHierarchies: true
    }
  }).then(response => response.toJS());
};
export const fetchBreakdownProperties = (reportType, breakdowns, schemaVersion) => http.post('reporting-metadata/v1/unified-events/breakdowns', {
  data: Object.assign({
    reportType,
    breakdowns
  }, schemaVersion && {
    schemaVersion
  })
}).then(response => response.toJS());
export const getUnifiedEventSchema = (reportType, schemaVersion) => {
  return fetchSchema(reportType, schemaVersion).then(parseSchema).then(schema => {
    const breakdownProperties = getBreakdownProperties(schema);
    return breakdownProperties.length ? fetchBreakdownProperties(reportType, breakdownProperties, schemaVersion).then(breakdownMetaData => hydrateSchema(schema, breakdownMetaData)) : schema;
  });
};
export const fetchCrmObjectProperties = (reportType, breakdown, schemaVersion) => {
  return http.post('reporting-metadata/v1/unified-events/breakdowns/referencedObjectProperties', {
    data: Object.assign({
      reportType,
      breakdown
    }, schemaVersion && {
      schemaVersion
    })
  }).then(response => {
    return response;
  });
};
export const resolveEventPropertyReferences = (referenceType, objectTypeId, referenceKeys) => {
  const path = objectTypeId ? `${objectTypeId}/${referenceType}` : `${referenceType}`;
  return http.post(`external-options/v2/fetch/${path}`, {
    data: {
      referenceType,
      ids: referenceKeys,
      portalId: PortalIdParser.get()
    }
  });
};